<template>
  <div class="about wrap bg-dark">
    <section class="section auto">
      <div class="contact-wrap">
        <h1 class="line-text">
          NANDSOFT Inc.
        </h1>
        <div class="space h100"></div>
        <dl class="contact-info">
          <dt>
            {{ $t('contact.info.fax.title') }}
          </dt>
          <dd>
            {{ $t('contact.info.fax.text') }}
          </dd>
        </dl>
        <dl class="contact-info">
          <dt>
            {{ $t('contact.info.address.daegu.title') }}
          </dt>
          <dd>
            {{ $t('contact.info.address.daegu.text') }}
          </dd>
        </dl>
        <dl class="contact-info">
          <dt>
            {{ $t('contact.info.address.seoul.title') }}
          </dt>
          <dd>
            {{ $t('contact.info.address.seoul.text') }}
          </dd>
        </dl>
        <dl class="contact-info">
          <dt>
            {{ $t('contact.info.email.title') }}
          </dt>
          <dd>
            {{ $t('contact.info.email.text', {account:'nandsoft', domain:'nandsoft.co.kr'}) }}
          </dd>
        </dl>
        <dl class="contact-info">
          <dt>
            {{ $t('contact.info.tel.title') }}
          </dt>
          <dd>
            {{ $t('contact.info.tel.text') }}
          </dd>
        </dl>
      </div>
    </section>
    <section class="half-h">
      <KakaoMap />
    </section>
  </div>
</template>
<script>
import KakaoMap from '@/components/KakaoMap'

export default {
  name: 'aboutMap',
  components: {
    KakaoMap
  }
}
</script>
